import { environment } from '../../../environments/environment';

export class ApiRecord {
  id: string;
  md5: string;
  owner: boolean;

  mp3Url: string;
  oggUrl: string;

  constructor(data: ApiRecord) {
    this.id = data.id;
    this.md5 = data.md5;
    this.owner = data.owner;

    this.mp3Url = `${environment.recordsUrl}${this.md5}.mp3`;
    this.oggUrl = `${environment.recordsUrl}${this.md5}.ogg`;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/entities/api-record.ts